import * as _ from 'lodash';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {Product, ProductJSON} from './product';
import {ApiResponse, AuthService, BaseService} from '@hassel-it/angular-common';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PriceRobotProductsService} from './price-robot-products.service';
import {PriceRobotFilter} from "./price-robot-filter";

@Injectable()
export class ProductsService extends BaseService {

    constructor(public http: HttpClient, public authService: AuthService, public priceRobotProductsService: PriceRobotProductsService ) {
        super(http, authService);
    }


    getCategoryGraphData(filter: PriceRobotFilter = null) {
        this.reloadHeaders();
        let params = new HttpParams();
        if (filter !== null) {
            params = this.priceRobotProductsService.buildQuery(filter);
        }

        return this.http.get(environment.apiBase + '/api/tenfour-crawler/products/category-graph-data', {
            headers: this.httpHeaders,
            params: params,
        });
    }

    getDeviationGraphData(filter: PriceRobotFilter = null) {
        this.reloadHeaders();
        let params = new HttpParams();
        if (filter !== null) {
            params = this.priceRobotProductsService.buildQuery(filter);
        }

        return this.http.get(environment.apiBase + '/api/tenfour-crawler/products/deviation-graph-data', {
            headers: this.httpHeaders,
            params: params,
        });

    }

    getPriceGraphData() {
        this.reloadHeaders();
        return this.http.get(environment.apiBase + '/api/tenfour-crawler/products/get-price-graph-data', {
            headers: this.httpHeaders
        });
    }
}
